import { dialog, InputJson, toDisplayCase } from "nq-component";
import { getObjectUseCase, upsertUseCase } from "../../../../usecases/object";
import withRouter from "../../../../withRouter";
import BaseFormPage from "../../../../base/BaseFormPage";
import NavBar from "../../../../components/navbar";
import FormFactory from "../../../../components/FormFactory";
import DialogModal from "../../../../components/Dialog";
import DialogTable from "../../../../components/DialogTable";
import BreakdownTable from "../../../../components/BreakdownTable";
import DirectPurchaseFormPresenter from "./DirectPurchaseFormPresenter";
import DirectPurchaseDetails from "./components/DirectPurchaseDetails";

class DirectPurchaseFormPage extends BaseFormPage {
  constructor(props) {
    super(props);
    this.state = { object: {}, advanced: false, selectedRawIds: [] };
    this.presenter = new DirectPurchaseFormPresenter(
      this,
      getObjectUseCase(),
      upsertUseCase()
    );
  }

  getCollectionName() {
    return "direct_purchase";
  }

  onClickAdvance() {
    this.setState({ advanced: !this.state.advanced });
  }

  onSubmitForm(e) {
    e.preventDefault();

    dialog.fire({
      html: (
        <DialogModal
          icon="bi bi-question-octagon-fill"
          iconColor="#82c14a"
          title="Confirm to Proceed"
          message="Are you sure want to continue this action?"
          isCancelButton={true}
          onSubmit={() => this.presenter.submit()}
          onClose={() => dialog.close()}
        />
      ),
      footer: false,
    });
  }

  handleOpenRaw() {
    const schema = this.getSchema("raw_materials");
    const user = this.getCurrentUser();
    const hasAdminRole = user?.roles?.some((role) => role.id === "Admin");
    const storeId = user?.storeAnalytic?.[0]?.id;
    dialog.fire({
      html: (
        <DialogTable
          title="raw_materials"
          where={{}}
          schema={schema}
          onCancel={() => dialog.close()}
          onSelect={(selectedItems) => {
            this.setState((prev) => {
              const existing = prev.object.raw_materials || [];

              const mergedMap = new Map();
              for (const item of existing) {
                mergedMap.set(item.id, item);
              }

              for (const item of selectedItems) {
                const inputQty = parseFloat(item.quantity || 0); // read qty from modal
                const unitCost = parseFloat(item.cost || 0); // treat cost as unit cost

                mergedMap.set(item.id, {
                  ...item,
                  unit_cost: unitCost,
                  quantity: inputQty,
                  cost: (inputQty * unitCost).toFixed(2), // now cost is total
                });
              }

              return {
                object: {
                  ...prev.object,
                  raw_materials: Array.from(mergedMap.values()),
                },
              };
            });
          }}
        />
      ),
      footer: false,
    });
  }

  handleDeleteSelected() {
    const { selectedRawIds, object } = this.state;
    const updated = (object.raw_materials || []).filter(
      (item) => !selectedRawIds.includes(item.id)
    );

    this.setState({
      object: {
        ...object,
        raw_materials: updated,
      },
      selectedRawIds: [], // reset after delete
    });
  }

  onChange(value, field) {
    if (field === "quantity") {
      const hasValue = value !== undefined && value !== null && value !== "";
      this.setState({ hasQuantity: hasValue });
    }

    this.presenter.onChange(value, field);
  }

  handleSelectAll = (e) => {
    const checked = e.target.checked;
    const allIds = (this.state.object.raw_materials || []).map(
      (item) => item.id
    );
    this.setState({
      selectedRawIds: checked ? allIds : [],
    });
  };

  handleSelectOne = (e, id) => {
    const { selectedRawIds } = this.state;
    const updated = e.target.checked
      ? [...selectedRawIds, id]
      : selectedRawIds.filter((itemId) => itemId !== id);
    this.setState({ selectedRawIds: updated });
  };

  handleChangeQuantity = (e, index) => {
    const value = e.target.value;
    const quantity = parseFloat(value) || 0;

    this.setState((prevState) => {
      const updatedMaterials = [...(prevState.object.raw_materials || [])];
      const unitCost = parseFloat(updatedMaterials[index].unit_cost || 0); // use preserved unit cost

      updatedMaterials[index] = {
        ...updatedMaterials[index],
        quantity: value,
        cost: (quantity * unitCost).toFixed(2),
      };

      return {
        object: {
          ...prevState.object,
          raw_materials: updatedMaterials,
        },
      };
    });
  };

  render() {
    const object = this.state.object;
    const params = this.getParams();
    console.log("params", params);
    console.log("object", object);
    const advanced = this.state.advanced;
    const schema = this.getSchema(this.getCollectionName());
    if (!schema) return <h1>no schema</h1>;
    const label = this.getObjectId() === undefined ? "Add " : "Edit ";
    return (
      <>
        <NavBar />
        <div className="overflow-auto">
          <div className="h-100">
            <div className="p-3 p-lg-4">
              <h2
                className="fw-bold mt-3 text-capitalize"
                style={{ color: "#82c14a" }}
              >
                <i
                  onClick={() => this.navigateBack()}
                  class="bi bi-chevron-compact-left"
                  style={{ color: "black" }}
                ></i>
                {label +
                  (schema.label || toDisplayCase(this.getCollectionName()))}
              </h2>
              <div
                className="mt-2 shadow rounded p-3 px-lg-5 py-lg-4"
                style={{ backgroundColor: "#f6f5fa" }}
              >
                <h6>Details</h6>
                <hr />
                <form onSubmit={this.onSubmitForm.bind(this)}>
                  <div className="row g-3">
                    {advanced ? (
                      <InputJson
                        defaultValue={object}
                        onChange={this.onChange.bind(this)}
                        rows="15"
                      />
                    ) : (
                      <>
                        {object?.id ? (
                          <DirectPurchaseDetails object={object} />
                        ) : (
                          <FormFactory
                            schema={schema}
                            object={object}
                            onChange={this.onChange.bind(this)}
                            excludeFields={[
                              "raw_materials",
                              "cost",
                              "sku",
                              "itemName",
                              "quantity",
                              "uom",
                              "price",
                            ]}
                          />
                        )}
                      </>
                    )}
                  </div>

                  {!object?.id && (
                    <BreakdownTable
                      title="Raw Materials Breakdown"
                      data={object.raw_materials || []}
                      selectedIds={this.state.selectedRawIds}
                      onSelectAll={this.handleSelectAll}
                      onSelectOne={this.handleSelectOne}
                      onChange={this.handleChangeQuantity}
                      onAdd={() => this.handleOpenRaw()}
                      onDelete={() => this.handleDeleteSelected()}
                      disableAdd={false}
                      hasQuantity={false}
                      showUOM={false}
                      showCost={true}
                    />
                  )}

                  <div className="mt-4 text-center">
                    {object?.id ? (
                      <button
                        type="button"
                        className="btn fs-sm text-white w-25"
                        onClick={this.onClickBack.bind(this)}
                        style={{ backgroundColor: "#82c14a" }}
                      >
                        Back
                      </button>
                    ) : (
                      <>
                        <button
                          type="button"
                          className="btn fs-sm "
                          onClick={this.onClickBack.bind(this)}
                          style={{ backgroundColor: "#d1d1d1" }}
                        >
                          Cancel
                        </button>
                        <button
                          type="submit"
                          className="btn fs-sm text-white ms-3"
                          style={{ backgroundColor: "#82c14a" }}
                        >
                          <i className="bi text-white bi-file-earmark-check me-2"></i>
                          Submit
                        </button>
                      </>
                    )}
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default withRouter(DirectPurchaseFormPage);
